<template>
  <div>
    <h2>{{ $t('workFileTracking.appointment.confirmTitle') }}</h2>
    <p>{{ $t('workFileTracking.appointment.confirmText') }}</p>
    <div class="row">
      <div class="col-xs-12 col-sm-5 col-md-5 col-sm-offset-1 col-md-offset-1">
        <a @click="confirmModify" class="lib__btn lib__btn--outline lib__btn--dark lib__btn--rounded" href="#" type="button">
          <span>{{ $t('workFileTracking.appointment.buttons.continue') }}</span>
        </a>
      </div>
      <div class="col-xs-12 col-sm-5 col-md-5 col-sm-offset-1 col-md-offset-1">
        <a @click="close" class="lib__btn lib__btn--primary lib__btn--rounded" href="#" type="button">
          <span>{{ $t('workFileTracking.appointment.buttons.cancel') }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Component from 'vue-class-component'
import { Emit, Vue } from 'vue-property-decorator'

@Component({ components: {} })
export default class AppointmentModificationConfirmation extends Vue {
  //#region [Emit]
  @Emit('confirmModify')
  public confirmModify() {
    return true
  }

  @Emit('close')
  private close() {
    return true
  }
  //#endregion
}
</script>
